import React from "react";
import "../Styles/OurMission.css";
import doctorImage from "../Images/About_US_Img.jpeg"; // Replace with your image path

const OurMission = () => {
  return (
    <section className="our-mission-wrapper">
      <h2 className="section-title">
        About Us <span className="underline"></span>
      </h2>

      <div className="our-mission-section">
        <div className="our-mission-text">
          <h3 className="mission-heading">Our Mission</h3>
          <p className="mission-para">
            At Northern Heights Dental, people come first. We help each of our
            patients to achieve optimal wellness and health by using a whole
            body approach to oral health. This means not just focusing on
            cavities, but focusing on; cranio-facial development, bite and joint
            balance, oral flora, proper muscle balance/function, and
            bio-compatibility of dental materials. Great care and planning
            ensure that everything we do helps promote overall health and well
            being.
          </p>

          <h4 className="happy-heading">
            More Than Anything Else We Love Creating Happy, Healthy Smiles.
          </h4>

          <p>
            We work hard to stay up to date with the most advanced techniques
            and technologies to ensure that our patients receive the best care
            possible. Our office utilizes 3D CBCT radiographs to allow for
            guided surgical and endodontic protocols. This enables these
            procedures to be performed digitally before they are performed
            surgically to ensure optimal results. 3D imaging also is utilized
            for the analysis of airway growth and development. We also use the
            best 3D optical scanner for all of our dental restoration and
            Invisalign impressions. Dr Williams is a strong advocate for using
            microsurgical techniques, this means less discomfort and faster
            healing times.
          </p>
        </div>

        <div className="our-mission-image">
          <img src={doctorImage} alt="Dentist at work" />
        </div>
      </div>
    </section>
  );
};

export default OurMission;
